'use client'

import { Button, Kbd, cn } from '@nextui-org/react'

import { useState } from 'react'
import { SearchAndChat } from '@holocron.so/prompt/src'
import { atoms } from 'website/src/lib/atoms'
import { getMarkdown } from 'website/src/lib/editor-utils'
import { useRootProps } from 'website/src/lib/hooks'
import { safeDecodeURIComponent, yDocToJson } from 'website/src/lib/utils'
import { getSearchData } from 'website/src/pages/api/functions'
import { SearchDataEntry } from '@holocron.so/prompt/src/types'
import { basename } from 'path'
import { mapHref } from '../../extensions/link'

export function Search({ className }) {
    const [isOpen, setOpen] = useState(false)
    const { siteId, pagesTree, branchId, projectType } = useRootProps()

    return (
        <>
            <Button
                variant='light'
                className={cn(
                    '!relative shrink-0 border-0 justify-start  ',
                    className,
                )}
                onClick={() => setOpen(true)}
            >
                <SearchIcon className='w-5' />

                <span className=''>Search </span>
                <div className='flex flex-col items-center justify-center absolute top-0 bottom-0 right-1'>
                    <Kbd
                        className='bg-white scale-80 dark:bg-gray-600 !rounded'
                        keys={['command']}
                    >
                        K
                    </Kbd>
                </div>
            </Button>
            <SearchAndChat
                {...{
                    namespace: siteId,
                    getSearchData: () =>
                        getSearchData({ siteId, branchId, projectType }),
                    isOpen,
                    initialResults: pagesTree.map((x) => {
                        const entry: SearchDataEntry = {
                            name: x.title || basename(x.slug),
                            slug: x.slug,
                            text: '',
                            // namespace: siteId,
                            type: 'page',
                        }
                        return entry
                    }),
                    setOpen,
                    currentPageText: getCurrentPageMarkdown(),

                    slugToHref: (slug) => {
                        const res = mapHref(slug)
                        // console.log({ slug, res })
                        return res
                    },
                }}
            />
        </>
    )
}
function getCurrentPageMarkdown() {
    return '' // TODO bug with this.marks is undefined
    if (typeof window === 'undefined') return ''
    const yDoc = atoms.document.get()
    if (!yDoc) {
        return ''
    }
    const pageSlug = window.location.pathname
    return getMarkdown(yDocToJson(yDoc), pageSlug)
}

function SearchIcon(props) {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' {...props}>
            <path
                fill='currentColor'
                d='m19.6 21l-6.3-6.3q-.75.6-1.725.95T9.5 16q-2.725 0-4.612-1.888T3 9.5q0-2.725 1.888-4.612T9.5 3q2.725 0 4.612 1.888T16 9.5q0 1.1-.35 2.075T14.7 13.3l6.3 6.3l-1.4 1.4ZM9.5 14q1.875 0 3.188-1.313T14 9.5q0-1.875-1.313-3.188T9.5 5Q7.625 5 6.312 6.313T5 9.5q0 1.875 1.313 3.188T9.5 14Z'
            ></path>
        </svg>
    )
}
